import SectionHeading from '@/components/base/SectionHeading';
import { danmakuRows } from '@/mocks/danmaku';

const rowStyles = [
  'bg-background-50/10 text-background-100 border-background-50/15',
  'bg-accent-500/15 text-accent-200 border-accent-500/30',
  'bg-secondary-500/15 text-secondary-100 border-secondary-500/30',
];

export default function DanmakuWall() {
  return (
    <section className="bg-foreground-950 py-14 md:py-20">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="rounded-lg border border-foreground-800 bg-foreground-900 p-4 md:p-8">
          <SectionHeading
            eyebrow="弹幕墙"
            title="满屏飞过的梗，比正片还上头"
            description="这是站内热度最高的弹幕合集。鼠标移上去可以让它们停下来，慢慢看。"
          />

          <div className="mt-8 space-y-4 overflow-hidden">
            {danmakuRows.map((row, rowIndex) => (
              <div key={rowIndex} className="relative overflow-hidden">
                <div
                  className="flex w-max gap-3"
                  style={{
                    animation: `danmaku-left ${26 + rowIndex * 6}s linear infinite`,
                    animationDirection: rowIndex === 1 ? 'reverse' : 'normal',
                  }}
                >
                  {[...row, ...row].map((item, index) => (
                    <span
                      key={`${item}-${index}`}
                      className={`whitespace-nowrap rounded-full border px-3 py-1.5 text-xs md:text-sm ${rowStyles[rowIndex]}`}
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 grid gap-4 border-t border-foreground-800 pt-6 sm:grid-cols-3">
            <div>
              <p className="font-heading text-2xl text-accent-400 md:text-3xl">22.6万</p>
              <p className="mt-1 text-xs text-background-300">单条内容最高弹幕量</p>
            </div>
            <div>
              <p className="font-heading text-2xl text-accent-400 md:text-3xl">1200+</p>
              <p className="mt-1 text-xs text-background-300">站内收录玩梗关键词</p>
            </div>
            <div>
              <p className="font-heading text-2xl text-accent-400 md:text-3xl">3 秒</p>
              <p className="mt-1 text-xs text-background-300">弹幕统一口径平均用时</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}